import React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';

type Props = Omit<LinkProps, 'to'>;

export default function LandingLink(props: Props) {
    const location = useLocation();
    const { children, ...rest } = props;
    return (
        <Link to={location.pathname} {...rest}>
            {children}
        </Link>
    );
}
